import { Table } from "../../../features/Table";
import { type E3Issuer, issuers_columns } from "./columns";
import { type FilterE3IssuersSchema, FilterE3Issuers } from "./filter";
import { useTranslation } from "react-i18next";

const client = "e3";
const table_name = "e3_issuers";

export const E3IssuersTable = () => {
  const { t } = useTranslation(["tables"]);
  return (
    <Table<E3Issuer, FilterE3IssuersSchema>
      label={t(`${table_name}.title`, { defaultValue: "Issuers" })}
      client={client}
      table_name={table_name}
      columns={issuers_columns}
      filter={<FilterE3Issuers />}
      actions={[
        {
          label: "actions.new",
          route: `${client}/${table_name}/new`,
        },
      ]}
    />
  );
};
